import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { ImageUpload, InputRange } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import Cropper from 'react-easy-crop';
import { useImageUpload } from './useImageUpload';

export const PetCoverImageUpload = ({
  newCoverImage,
  setNewCoverImage,
  setCroppedPetCoverAreaPixels,
  setCoverFileName
}) => {
  const [isPetCoverChanged, setIsPetCoverChanged] = useState(false);
  const fileProfileInputRef = useRef(null);

  const onCropComplete = useCallback(
    (_, croppedAreaPixels) => {
      setCroppedPetCoverAreaPixels(croppedAreaPixels);
    },
    [setCroppedPetCoverAreaPixels]
  );

  const { formContext, handleImageChange, handleDrop, crop, setCrop, zoom, setZoom, validImageFiles } = useImageUpload(
    setNewCoverImage,
    setCoverFileName,
    setIsPetCoverChanged
  );

  return (
    <fieldset>
      {!isPetCoverChanged && (
        <ImageUpload
          name="petCoverImage"
          allowMultiple={false}
          fieldFormContext={formContext}
          validation={{}}
          inputType="file"
          labelStyle="image"
          listStyle="reveal"
          imageUrl={newCoverImage}
          customChangeHandler={handleImageChange}
        />
      )}
      {newCoverImage && isPetCoverChanged && (
        <div
          className="imageEditorContainer"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          <div className="avatarEditorContainer">
            <div className="cropper">
              <Cropper
                name="petCoverImageCropper"
                image={newCoverImage}
                crop={crop}
                zoom={zoom}
                aspect={1}
                showGrid={false}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
            <InputRange
              name="zoomCoverImage"
              type="range"
              customCssClass="zoomRange"
              min="1"
              max="3"
              step="0.1"
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
            />
          </div>
          <div className="changeImageButton">
            <input
              type="file"
              ref={fileProfileInputRef}
              multiple={false}
              accept={validImageFiles}
              style={{ display: 'none' }}
              onChange={handleImageChange}
            />

            <button
              type="button"
              className="button primary"
              onClick={() => fileProfileInputRef.current && fileProfileInputRef.current.click()}
            >
              Upload another image
            </button>
            <span>
              or
              <br />
              Drag and drop an image here to upload it
            </span>
          </div>
        </div>
      )}
    </fieldset>
  );
};

PetCoverImageUpload.propTypes = {
  newCoverImage: PropTypes.string,
  setNewCoverImage: PropTypes.func,
  setCroppedPetCoverAreaPixels: PropTypes.func,
  setCoverFileName: PropTypes.func
};
